export const operatorsList = [
  {
    key: 'EQUALS',
    title: 'Equals',
  },
  {
    key: 'NOT_EQUALS',
    title: "Doesn't Equal",
  },
  {
    key: 'LESS_THAN',
    title: 'Less Than',
    number: true,
  },
  {
    key: 'LESS_EQUALS',
    title: 'Less Than or Equal To',
    number: true,
  },
  {
    key: 'GREATER_THAN',
    title: 'Greater Than',
    number: true,
  },
  {
    key: 'GREATER_EQUALS',
    title: 'Greater Than or Equal To',
    number: true,
  },
  {
    key: 'AND',
    title: 'Includes All of the Following',
    multi: true,
  },
  {
    key: 'OR',
    title: 'Includes at Least One of the Following',
    multi: true,
  },
];

export const actionsList = [
  {
    key: 'FOLLOW_UP_QUESTION',
    title: 'Follow Up Question',
  },
  {
    key: 'SEND_NOTIFICATION',
    title: 'Send Notification',
  },
  {
    key: 'SHOW_MESSAGE',
    title: 'Show Message',
  },
  {
    key: 'SHOW_POP_UP',
    title: 'Pop Up',
  },
  {
    key: 'SHOW_FILE',
    title: 'File',
  },
  {
    key: 'FOLLOW_UP_TEMPLATE',
    title: 'Follow Up Template',
  },
  {
    key: 'FOLLOW_UP_CATEGORY',
    title: 'Follow Up Category',
  },
  {
    key: 'PREFILL_ANSWER',
    title: 'Prefill Answer',
  },
];

export const actionsKeys = {
  sendNotification: 'SEND_NOTIFICATION',
  followUpQuestion: 'FOLLOW_UP_QUESTION',
  showMessage: 'SHOW_MESSAGE',
  popUp: 'SHOW_POP_UP',
  showFile: 'SHOW_FILE',
  followUpTemplate: 'FOLLOW_UP_TEMPLATE',
  followUpCategory: 'FOLLOW_UP_CATEGORY',
  prefillAnswer: 'PREFILL_ANSWER',
};

export const defaultTestValueList = [
  {
    title: 'Pass',
    key: 'PASS',
  },
  {
    title: 'Fail',
    key: 'FAIL',
  },
  {
    title: 'N/A',
    key: 'NOT_APPLICABLE',
  },
];

export const testValueList = [
  {
    title: 'Pass',
    key: 'PASS',
  },
  {
    title: 'Fail',
    key: 'FAIL',
  },
  {
    title: 'N/A',
    key: 'NOT_APPLICABLE',
  },
  {
    title: 'Ok',
    key: 'PASS',
  },
  {
    title: 'OK',
    key: 'PASS',
  },
  {
    title: 'Issue',
    key: 'FAIL',
  },
  {
    title: 'Yes',
    key: 'PASS',
  },
  {
    title: 'No',
    key: 'FAIL',
  },
  {
    title: 'Acceptable',
    key: 'PASS',
  },
  {
    title: 'Unacceptable',
    key: 'FAIL',
  },
];

export const conditionalActionsAllowed = [
  'TEST',
  'NUMBER',
  'TEXT',
  'TEXT_MULTI',
  'DATE',
  'DATE_TIME',
  'TIME',
  'SELECT_SINGLE',
  'SELECT_MULTI',
  'SELECT_CHECKLIST',
  'DROPDOWN_SINGLE',
  'DROPDOWN_MULTI',
];

// Types whose answer supports ordering comparisons (LESS_THAN, GREATER_THAN, etc).
const orderableInputTypes = ['NUMBER', 'DATE', 'DATE_TIME', 'TIME'];

// Types whose answer is a pipe-delimited set of values, so AND/OR ("includes
// all/at least one of") operators are meaningful against it.
const multiValueInputTypes = [
  'SELECT_MULTI',
  'SELECT_CHECKLIST',
  'DROPDOWN_MULTI',
];

// Which operators remain valid for a given input type, so a question's
// existing conditions can be checked for compatibility with a new input type
// before they're wiped out. EQUALS/NOT_EQUALS are universally valid except
// for TEXT/TEXT_MULTI, which only ever expose EQUALS in the condition editor.
export const getCompatibleOperatorKeys = (inputType) => {
  if (!conditionalActionsAllowed.includes(inputType)) return [];
  if (inputType === 'TEXT' || inputType === 'TEXT_MULTI') return ['EQUALS'];
  return operatorsList
    .filter((o) => !o.number || orderableInputTypes.includes(inputType))
    .filter((o) => !o.multi || multiValueInputTypes.includes(inputType))
    .map((o) => o.key);
};

export const months = [
  { title: 'January', key: '01' },
  { title: 'February', key: '02' },
  { title: 'March', key: '03' },
  { title: 'April', key: '04' },
  { title: 'May', key: '05' },
  { title: 'June', key: '06' },
  { title: 'July', key: '07' },
  { title: 'August', key: '08' },
  { title: 'September', key: '09' },
  { title: 'October', key: '10' },
  { title: 'November', key: '11' },
  { title: 'December', key: '12' },
];

export const days = Array.from({ length: 31 }, (_, i) => i + 1);

export const actionIcons = {
  message: 'message',
  file: 'topic',
  template: 'description',
  category: 'category',
  notification: 'notifications',
  popUp: 'upcoming',
  prefillAnswer: 'auto_fix_high',
};
